import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { LEDGER } from "@/data/content";
import { EASE } from "./Reveal";

const Curve = () => (
  <svg viewBox="0 0 300 110" className="w-full h-24 mt-6" aria-hidden="true">
    {[0, 1, 2, 3].map((i) => (
      <line key={i} x1="0" x2="300" y1={10 + i * 30} y2={10 + i * 30} stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
    ))}
    <motion.path
      d="M0 100 C 60 96, 90 88, 120 74 S 190 50, 220 34 S 270 12, 300 6"
      fill="none"
      stroke="#B8874A"
      strokeWidth="1.5"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 2.2, delay: 1.2, ease: EASE }}
    />
    <motion.circle cx="300" cy="6" r="3.5" fill="#B8874A" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 3.2 }} />
  </svg>
);

export const Ledger = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [7, -7]), { stiffness: 80, damping: 20 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-9, 9]), { stiffness: 80, damping: 20 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <div className="[perspective:1400px]" onMouseMove={onMove} onMouseLeave={reset}>
      <motion.div
        style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.4, delay: 0.9, ease: EASE }}
        className="relative border border-white/15 bg-white/[0.035] backdrop-blur-md p-7 sm:p-8"
        data-testid="hero-ledger"
      >
        <div className="absolute -top-px left-8 right-8 h-px bg-gradient-to-r from-transparent via-[#B8874A] to-transparent" />
        <div className="flex items-baseline justify-between" style={{ transform: "translateZ(30px)" }}>
          <span className="eyebrow">The operating record</span>
          <span className="font-display italic text-white/60 text-sm">2007 — now</span>
        </div>
        <ul className="mt-6" style={{ transform: "translateZ(20px)" }}>
          {LEDGER.map((row, i) => (
            <motion.li
              key={row.org}
              className="grid grid-cols-[64px_1fr] gap-4 py-3.5 border-t border-white/10"
              initial={{ opacity: 0, x: -12 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1.4 + i * 0.12, duration: 0.8, ease: EASE }}
            >
              <span className="font-display text-[#D2A86E] text-sm pt-0.5">{row.year}</span>
              <span>
                <span className="block text-white text-[15px]">{row.org}</span>
                <span className="block text-white/60 text-[13px] mt-0.5">{row.note}</span>
              </span>
            </motion.li>
          ))}
        </ul>
        <div style={{ transform: "translateZ(40px)" }}>
          <Curve />
        </div>
      </motion.div>
    </div>
  );
};
